import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { CdwIconComponent } from './cdw-icon/cdw-icon.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule],
  declarations: [CdwIconComponent],
  exports: [CdwIconComponent],
})
export class CdwIconModule {}
